module.exports = __webpack_public_path__ + "static/media/college-application-checklist.a6f7410a.pdf";